<template>
  <el-row :class="['zerno-progress', { mobile: mobile }]">
    <el-row :class="['zerno-progress__outer', { mobile: mobile }]">
      <el-col
        v-for="(item, i) in getPercentages"
        :key="i"
        :class="['zerno-progress__bar', `is-${item.color}`, { mobile: mobile }]"
        :style="`width:${item.percentage}%`"
      />
    </el-row>
    <el-row v-if="!mobile" class="zerno-progress__text">
      {{ getPercentages[0].percentage }}%
    </el-row>
  </el-row>
</template>

<script>
export default {
  props: {
    percentages: {
      type: Object,
      default: () => {},
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getPercentages() {
      const { dayCarsCount, notServedCount, approvedCount, requestCount } = this.percentages
      const responded = { color: 'info', percentage: 0 }
      const approved = { color: 'success', percentage: 0 }
      const requested = { color: 'request', percentage: 0 }

      const respPercentage = Math.round(
        (notServedCount / (dayCarsCount || 1)) * 100,
      )
      const apprPercentage = Math.round((approvedCount / dayCarsCount) * 100)
      const requestPercentage = Math.round((requestCount / dayCarsCount) * 100)

      approved.percentage = apprPercentage > 100 ? 100 : apprPercentage
      responded.percentage = respPercentage > 100 ? 100 : respPercentage
      requested.percentage = requestPercentage > 100 ? 100 : requestPercentage

      // проверки на превышение 100 длины прогресс-бара, если что - отсекаем лишнее
      if (approved.percentage + responded.percentage + requested.percentage > 100) {
        if (100 - approved.percentage < responded.percentage) {
          responded.percentage = 100 - approved.percentage
          requested.percentage = 0
        } else {
          requested.percentage = 100 - approved.percentage - responded.percentage
        }
      }

      return [approved, responded, requested]
    },
  },
  methods: {
    getBarStyles(item) {
      return {
        width: `${item.percentage}%`,
      }
    },
  },
}
</script>

<style lang="scss">
.zerno-progress {
  height: 10px;
  width: 100%;
  margin-right: 10px;
  display: flex;
  align-items: center;
  &.mobile {
    height: 17px;
  }
  &__outer {
    height: 100%;
    flex: 0 0 92%;
    border-radius: 100px;
    background-color: #ebeef5;
    overflow: hidden;
    position: relative;
    vertical-align: middle;
    &.mobile {
      flex: 0 0 100%;
      background-color: #fff;
      border: 1px solid #cacaca;
      border-radius: 5px;
    }
  }
  &__bar {
    height: 100%;
    &.is-info {
      background-color: #409eff;
    }
    &.is-success {
      background-color: #5daf34;
    }
    &.is-request {
      background-color: #7c8185;
    }
  }
  &__text {
    margin-left: auto;
    font-size: 14px;
    color: #000;
  }
}
</style>
